import { Component, DestroyRef, inject } from '@angular/core';
import {
  faBoxesStacked,
  faReceipt,
  faLineChart,
  faHistory,
  faWallet,
  faFileImport,
} from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from '../services/global.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-rekavoze',
  imports: [FaIconComponent],
  templateUrl: './rekavoze.component.html',
  styleUrl: './rekavoze.component.scss',
})
export class RekavozeComponent {
  private globalService = inject(GlobalService);
  private destroyRef = inject(DestroyRef);
  icons = {
    inventory: faBoxesStacked,
    expense: faReceipt,
    analytics: faLineChart,
    audit: faHistory,
    budget: faWallet,
    io: faFileImport,
  };

  constructor() {
    this.globalService.hideFooterCTA();
    this.destroyRef.onDestroy(() => {
      this.globalService.showFooterCTA();
    });
  }
}
